export type WaitlistStatus = "pending" | "approved" | "rejected" | "invited";

export interface IWaitlist {
  id?: string;
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  source?: string;
  status: WaitlistStatus;
  reviewedAt?: string;
  reviewedBy?: string;
  reviewNotes?: string;
  message?: string;
  invitedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export const waitlistEntryId = (item: Pick<IWaitlist, "id" | "_id">) =>
  item.id || item._id;
